(function () {
  if (window.cxLoaded) return;
  window.cxLoaded = true;

  // Carousel arrows (reviews, thumbnails)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cx-scroll]');
    if (!btn) return;
    var wrap = btn.closest('[data-cx-carousel]');
    var track = wrap && wrap.querySelector('[data-cx-track]');
    if (!track) return;
    var first = track.firstElementChild;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({ left: btn.getAttribute('data-cx-scroll') === 'next' ? step : -step, behavior: 'smooth' });
  });

  function initPdp(root) {
    if (!root || root.dataset.cxReady) return;
    root.dataset.cxReady = '1';
    var idInput = root.querySelector('[data-cx-id]');
    var qtyInput = root.querySelector('[data-cx-qty]');
    var planInput = root.querySelector('[data-cx-plan]');
    var priceEl = root.querySelector('[data-cx-atc-price]');
    var labelEl = root.querySelector('[data-cx-atc-label]');
    var atc = root.querySelector('[data-cx-atc]');
    var mainImg = root.querySelector('[data-cx-main-img]');
    var mode = 'onetime';

    function update() {
      var b = root.querySelector('[data-cx-bundle].is-active') || root.querySelector('[data-cx-bundle]');
      if (!b || !idInput) return;
      idInput.value = b.dataset.variant;
      qtyInput.value = b.dataset.qty;
      var sub = mode === 'subscribe' && b.dataset.subFmt;
      if (planInput) planInput.disabled = !sub;
      if (priceEl) priceEl.textContent = sub ? b.dataset.subFmt : b.dataset.priceFmt;
      var avail = b.dataset.available === 'true';
      if (atc) atc.disabled = !avail;
      if (labelEl) labelEl.textContent = avail ? labelEl.dataset.label : labelEl.dataset.soldout;
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cx-bundle]');
      if (b) {
        root.querySelectorAll('[data-cx-bundle]').forEach(function (x) {
          x.classList.toggle('is-active', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        update();
        return;
      }
      var p = e.target.closest('[data-cx-purchase]');
      if (p) {
        mode = p.getAttribute('data-cx-purchase');
        root.querySelectorAll('[data-cx-purchase]').forEach(function (x) {
          x.classList.toggle('is-active', x === p);
          x.setAttribute('aria-pressed', x === p ? 'true' : 'false');
        });
        update();
        return;
      }
      var t = e.target.closest('[data-cx-thumb]');
      if (t && mainImg) {
        mainImg.removeAttribute('srcset');
        mainImg.src = t.dataset.src;
        root.querySelectorAll('[data-cx-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      }
    });

    var eta = root.querySelector('[data-cx-eta]');
    if (eta) {
      var d = new Date();
      d.setDate(d.getDate() + parseInt(eta.dataset.days || '3', 10));
      eta.textContent = d.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
    }
    update();
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-cx-pdp]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

(function () {
  if (window.cxReviewsLoaded) return;
  window.cxReviewsLoaded = true;
  function apply(root) {
    var filter = root.dataset.cxActive || 'all';
    var limit = root.dataset.cxExpanded ? 9999 : parseInt(root.dataset.visible || '6', 10);
    var shown = 0, matched = 0;
    root.querySelectorAll('[data-cx-tags]').forEach(function (card) {
      var ok = (' ' + card.dataset.cxTags + ' ').indexOf(' ' + filter + ' ') > -1;
      if (ok) matched++;
      var show = ok && shown < limit;
      if (show) shown++;
      card.hidden = !show;
    });
    var more = root.querySelector('[data-cx-more]');
    if (more) more.hidden = matched <= shown;
  }
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cx-filter]');
    var more = e.target.closest('[data-cx-more]');
    var root = (chip || more) && (chip || more).closest('[data-cx-reviews]');
    if (!root) return;
    if (chip) {
      root.dataset.cxActive = chip.dataset.cxFilter;
      root.querySelectorAll('[data-cx-filter]').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
    }
    if (more) root.dataset.cxExpanded = '1';
    apply(root);
  });
  function init(scope) { (scope || document).querySelectorAll('[data-cx-reviews]').forEach(apply); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
